import { render } from "./LoginApprovals.vue?vue&type=template&id=46d4e1d8"
import script from "./LoginApprovals.vue?vue&type=script&lang=js"
export * from "./LoginApprovals.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__